module.exports = __webpack_public_path__ + "img/99@2x.6befd06e.png";